import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
//import { useNavigate } from 'react-router-dom';

import Homepage from './components/LoginSignup/Homepage';
import Signin from './components/LoginSignup/Signin';
import Signup from './components/LoginSignup/Signup';
import ForgotPassword from './components/LoginSignup/ForgotPassword';
import PdfUpload from './components/LoginSignup/PdfUpload';
import TextExtraction from './components/LoginSignup/TextExtraction';
import Translation from './components/LoginSignup/Translation';
import Audiogeneration from './components/LoginSignup/Audiogeneration';
import TextSummarization from './components/LoginSignup/TextSummarization';
import VideoGeneration from './components/LoginSignup/videoGeneration';
import TestPdfViewer from './components/LoginSignup/TestPdfViewer';


function App() {
  return (

    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          { /*<Route path="/" element={<Signin />} /> */}
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/upload" element={<PdfUpload />} />
          <Route path="/text-extraction" element={<TextExtraction />} />
          <Route path="/Translation" element={<Translation />} />
          <Route path="/Audiogeneration" element={<Audiogeneration />} />
          <Route path="/TextSummarization" element={<TextSummarization />} />
          <Route path="/videogeneration" element={<VideoGeneration />} />
          <Route path="/test-pdf" element={<TestPdfViewer />} />
        </Routes>
      </Router>
    </AppProvider>

  );
}

export default App;
